import { useMemo } from 'react';

import { type LinkItemResponse } from '@atlassian/navigation-bff-data-provider';

export function buildLinkItemUrl(item: LinkItemResponse) {
	if (!item.href || !item.hostname) {
		return '';
	}

	const base = item.hostname.startsWith('https://') ? item.hostname : `https://${item.hostname}`;
	const targetUrl = new URL(item.href, base);

	// Add query parameters from options
	for (const [key, value] of Object.entries(item.options || {})) {
		if (value !== null) {
			targetUrl.searchParams.append(key, String(value));
		}
	}

	// Handle session sync URL logic
	if (!item.sessionSyncUrl) {
		// When session sync URL is empty, return the current URL
		return targetUrl.toString();
	}

	// When session sync URL is set, use it as base and set continue param to current URL
	const sessionSyncUrl = new URL(item.sessionSyncUrl);
	sessionSyncUrl.searchParams.set('continue', targetUrl.toString());

	return sessionSyncUrl.toString();
}

export function useLinkItemConfig(item: LinkItemResponse) {
	const href = useMemo(() => buildLinkItemUrl(item), [item]);

	return {
		target: item.target,
		rel: 'noopener noreferrer',
		href,
	};
}
